import React, { useState } from "react";
import { alertError, alertSuccess } from "../../../../utils/logger";

import {
    Button, TextField, Tooltip,
    Dialog, DialogActions, DialogContent, DialogTitle
} from "@material-ui/core";
import Table, { buttonsStyle } from "../../../components/tables/table";
import { changeStatusUserCustomer, deleteUserCustomer, signUpUserCustomer, updateUserCustomer } from "../../../../api/userCustomer";
import EditIcon from "@material-ui/icons/Edit";

import DeleteIcon from "@material-ui/icons/Delete";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

function getEmptyUser() {
    return {
        _id: null,
        fullName: '',
        email: '',
        password: '',
        active: true
    }
}

function getNewPassword() {
    return {
        password: null,
        repeatPassword: null
    }
}

function userDialog(isNew, userSelected, setUserSelected, userOpen, setUserOpen, users, setUsers, setTableKeyUsers, newPassword, setNewPassword, changePassword, setChangePassword, customer) {
    const dialogTitle = isNew ? "Create user" : "Edit user";

    const handleChange = (element) => (event) => {
        setUserSelected({ ...userSelected, [element]: event.target.value })
    }

    function saveUser() {
        if (userSelected.fullName === '') {
            alertError({ error: null, customMessage: 'Name is required.' });
            return;
        }
        if (userSelected.email === '') {
            alertError({ error: null, customMessage: 'Email is required.' });
            return;
        }

        if ((!userSelected.email.includes('@') || !userSelected.email.includes('.'))) {
            alertError({ error: null, customMessage: 'Invalid email format.' });
            return;
        }

        if (!userSelected._id || changePassword) {
            if (!newPassword.password || !newPassword.repeatPassword) {
                alertError({ error: null, customMessage: 'Please enter the password.' });
                return;
            }
            if (newPassword.password !== newPassword.repeatPassword) {
                alertError({ error: null, customMessage: 'Passwords do not match.' });
                return;
            }
            userSelected.password = newPassword.password
        }

        if (customer?._id) {
            userSelected.customerId = customer._id

            if (!userSelected._id) {
                signUpUserCustomer(userSelected).then((res) => {
                    setUsers([...users, res.data.user])
                    alertSuccess({ title: 'Saved!', customMessage: 'User successfully created.' })
                    setTableKeyUsers(k => k + 1);
                    setUserSelected(getEmptyUser())
                    setUserOpen(false)
                }).catch(error => {
                    alertError({ error: error, customMessage: 'Could not save user.' })
                })
            }
            else {
                updateUserCustomer(userSelected._id, userSelected).then(res => {
                    const updatedUsers = users.map((user) =>
                        user._id === userSelected._id
                            ? userSelected
                            : user
                    );
                    setUsers(updatedUsers)
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Changes successfully saved.",
                    });
                    setTableKeyUsers(k => k + 1);
                    setUserSelected(getEmptyUser())
                    setUserOpen(false)
                }).catch(error => {
                    alertError({
                        error: error,
                        customMessage: "Could not save changes.",
                    });
                })
            }
        } else {

            if (isNew)
                setUsers([...users, userSelected]);
            else {
                const updateUsers = users?.filter((user) => user?.email !== userSelected?.email);
                setUsers(updateUsers)
            }

            setTableKeyUsers(k => k + 1);
            setUserOpen(false)
        }


    }

    return (
        <Dialog
            open={userOpen}
            onClose={() => setUserOpen(false)}
            aria-labelledby="confirm-dialog"
            PaperProps={{
                style: {
                    width: '50vw',
                    height: '50vh',
                    maxWidth: 'none'
                }
            }}>
            <DialogTitle id="confirm-dialog">{dialogTitle}</DialogTitle>
            <DialogContent style={{ overflowX: 'hidden' }}>
                <div className="d-flex align-item-center">
                    <div className="col-5">
                        <TextField
                            label="Full name"
                            value={userSelected.fullName}
                            onChange={handleChange('fullName')}
                            margin="normal"
                            variant="outlined"
                            required
                        />
                    </div>
                    <div className="col-5">
                        <TextField
                            label="Email"
                            value={userSelected.email}
                            onChange={handleChange('email')}
                            margin="normal"
                            variant="outlined"
                            required
                        />
                    </div>
                </div>
                <div className="d-flex flex-wrap align-item-center">
                    {isNew || changePassword ? (
                        <>
                            <div className="col-5">
                                <TextField
                                    label="Password"
                                    type="password"
                                    value={newPassword.password}
                                    onChange={(e) =>
                                        setNewPassword({
                                            ...newPassword,
                                            password: e.target.value,
                                        })
                                    }
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    required
                                />
                            </div>
                            <div className="col-5">
                                <TextField
                                    label="Repeat Password"
                                    type="password"
                                    value={newPassword.repeatPassword}
                                    onChange={(e) =>
                                        // if (event.target.value !== ' ')
                                        setNewPassword({
                                            ...newPassword,
                                            repeatPassword: e.target.value,
                                        })
                                    }
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    required
                                />
                            </div>
                            <div className="col-2" />

                            {!isNew && (
                                <>
                                    <div className="col-7" />
                                    <div className="d-flex align-item-center mt-2">
                                        <Button
                                            onClick={() => {
                                                setChangePassword(false);
                                                setNewPassword(getNewPassword());
                                            }}
                                            variant="outlined"
                                        >
                                            Cancel change password
                                        </Button>
                                    </div>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <Button
                                onClick={() => setChangePassword(true)}
                                variant="outlined"
                                color="primary"
                                style={{ marginTop: 10, marginLeft: 10 }}
                            >
                                Change password
                            </Button>
                        </>
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => saveUser()}
                >
                    Save
                </Button>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                        setUserOpen(false)
                        setUserSelected(getEmptyUser())
                        setNewPassword(getNewPassword())

                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default function UserSection({ users, setUsers, customer }) {

    const [tableKeyUsers, setTableKeyUsers] = useState(0);
    const [isNew, setIsNew] = useState(false);
    const [userOpen, setUserOpen] = useState(false);
    const [userSelected, setUserSelected] = useState(getEmptyUser())
    const [newPassword, setNewPassword] = useState(getNewPassword())
    const [changePassword, setChangePassword] = useState(false)

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);


    function buttonFormatter(cell) {

        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setUserSelected(cell)
                            setUserOpen(true)
                            setIsNew(false)
                        }
                        }
                    >
                        <EditIcon />
                    </Button>
                </Tooltip>
                {cell?._id && (
                    <>
                        <Tooltip title={cell?.active ? "Disable" : "Enable"}>
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setUserSelected(cell);
                                    setOpenConfirmDialog(1);
                                }}
                            >
                                {cell?.active ? (
                                    <ToggleOffIcon />
                                ) : (
                                    <ToggleOnIcon style={{ color: "red" }} />
                                )}
                            </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setUserSelected(cell);
                                    setOpenConfirmDialog(2);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
            </>
        );
    }

    const columns = [
        { dataField: 'fullName', text: 'Full name', sort: true },
        { dataField: 'email', text: 'Email', sort: true },
        {
            dataField: '_id', text: '',
            formatter: (cell, row) => buttonFormatter(row),
            headerStyle: { width: '150px' }
        }
    ]

    return (
        <>
            {(customer?._id || users?.length === 0) && <div className="d-flex justify-content-end col-12">
                <button
                    type="button"
                    className="btn btn-primary text-white"
                    onClick={() => {
                        setUserOpen(true)
                        setIsNew(true)
                        setNewPassword(getNewPassword())
                        setUserSelected(getEmptyUser())
                    }}
                >
                    Add new
                </button>
            </div>}

            <div className="col-12 mb-2">
                <Table data={users || []} columns={columns} key={tableKeyUsers} />
            </div>

            {userDialog(isNew, userSelected, setUserSelected, userOpen, setUserOpen, users, setUsers, setTableKeyUsers, newPassword, setNewPassword, changePassword, setChangePassword, customer)}

            <ConfirmDialog
                title={`Are you sure you want to ${userSelected?.active ? 'disable' : 'enable'} this user?`}
                open={openConfirmDialog === 1}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {

                    changeStatusUserCustomer(userSelected._id, !userSelected?.active)
                        .then((res) => {
                            console.log(res.data)
                            const newData = users.map((userC) => userC?._id === userSelected._id ? res.data : userC);
                            setUsers(newData)

                            alertSuccess({ title: `${userSelected?.active ? 'Disabled!' : 'Enabled!'}`, customMessage: `User ${userSelected?.active ? 'disabled' : 'enabled'} successfully` })
                            setTableKeyUsers(k => k + 1);
                            setUserSelected(getEmptyUser())

                        })
                        .catch((error) => {
                            alertError({ error: error, customMessage: `Could not ${userSelected?.active ? 'disable' : 'enable'} user.` })
                        });
                }}
            />

            <ConfirmDialog
                title={'Are you sure you want to remove this user?'}
                open={openConfirmDialog === 2}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    deleteUserCustomer(userSelected._id)
                        .then((res) => {
                            const newData = users.filter((userC) => userC?._id !== userSelected._id);
                            setUsers(newData)

                            alertSuccess({
                                title: 'Deleted!',
                                customMessage: 'User removed successfully.',
                            });
                            setTableKeyUsers(k => k + 1);
                            setUserSelected(getEmptyUser())

                        })
                        .catch((error) => {
                            alertError({
                                error: error,
                                customMessage: 'Could not remove user.',
                            });
                        });
                }}
            />
        </>
    );
}